
import { Routes, RouterModule } from '@angular/router';

import { AuthComponent } from './auth/auth.component';
import { PublicComponent } from './public/public.component';
import { TutorPanelComponent } from './tutor-panel/tutor-panel.component';
import { VisualizadorComponent } from './modules/visualizador/visualizador.component';
import { AuthGuardService } from './services/auth-guard.service';

export const AppRoutes: Routes = [
    {
        path: '',
        redirectTo: 'active-directory',
        pathMatch: 'full',
    },
    {
        path: '',
        component: AuthComponent,
        children: [
            {
                path: 'active-directory',
                canLoad: [ AuthGuardService ],
                loadChildren: './auth/active-directory/active-directory.module#ActiveDirectoryModule'
            },
            {
                path: 'login',
                canLoad: [ AuthGuardService ],
                loadChildren: './auth/login/login.module#LoginModule'
            },
            {
                path: 'recovery',
                loadChildren: './auth/recovery/recovery.module#RecoveryModule'
            }
        ]
    },
    {
        path: '',
        component: VisualizadorComponent,
        canActivate: [AuthGuardService],
        children: [{
            path: 'visualizador',
            canLoad: [ AuthGuardService ],
            loadChildren: './modules/visualizador/visualizador.module#VisualizadorModule'
        }]
    },
    {
        path: '',
        canActivate: [AuthGuardService],
        component: PublicComponent,
        children: [
            {
                path: 'home',
                canLoad: [ AuthGuardService ],
                loadChildren: './public/home/home.module#HomeModule'
            },
            {
                path: 'training',
                canLoad: [ AuthGuardService ],
                loadChildren: './public/training/training.module#TrainingModule'
            },
            {
                path: 'development',
                canLoad: [ AuthGuardService ],
                loadChildren: './public/development/development.module#DevelopmentModule'
            },
            {
                path: 'influencers',
                canLoad: [ AuthGuardService ],
                loadChildren: './public/influencers/influencers.module#InfluencersModule'
            },
            {
                path: 'videos',
                canLoad: [ AuthGuardService ],
                loadChildren: './public/videos/videos.module#VideosModule'
            },
            {
                path: 'articles',
                canLoad: [ AuthGuardService ],
                loadChildren: './public/articles/articles.module#ArticlesModule'
            },
            {
                path: 'forum',
                canLoad: [ AuthGuardService ],
                loadChildren: './public/forum/forum.module#ForumModule'
            },
            {
                path: 'my-page',
                canLoad: [ AuthGuardService ],
                loadChildren: './public/my-page/my-page.module#MyPageModule'
            },
            {
                path: 'my-page-unit',
                canLoad: [ AuthGuardService ],
                loadChildren: './public/unit-leader/unit-leader.module#UnitLeaderModule'
            },
            {
                path: 'notice',
                canLoad: [ AuthGuardService ],
                loadChildren: './public/notice/notice.module#NoticeModule'
            },
            {
                path: 'welcome',
                canLoad: [ AuthGuardService ],
                loadChildren: './public/welcome/welcome.module#WelcomeModule'
            },
            {
                path: 'search',
                canLoad: [ AuthGuardService ],
                loadChildren: './public/search/search.module#SearchModule'
            },
            {
                path: 'technical',
                canLoad: [ AuthGuardService ],
                loadChildren: './public/technical/technical.module#TechnicalModule'
            },
            {
                path: 'ecosystem',
                canLoad: [ AuthGuardService ],
                loadChildren: './public/technical/technical.module#TechnicalModule'
            },
            {
                path: 'clients-plus',
                canLoad: [ AuthGuardService ],
                loadChildren: './public/technical/technical.module#TechnicalModule'
            },
            {
                path: 'contribuitors',
                canLoad: [ AuthGuardService ],
                loadChildren: './public/contributors/contributors.module#ContributorsModule'
            },
            {
                path: 'notifications',
                canLoad: [ AuthGuardService ],
                loadChildren: './public/notifications/notifications.module#NotificationsModule'
            },
            {
                path: 'helpdesk',
                canLoad: [ AuthGuardService ],
                loadChildren: './public/helpdesk/helpdesk.module#HelpdeskModule'
            },
            {
                path: 'voucher',
                canLoad: [ AuthGuardService ],
                loadChildren: './public/voucher/voucher.module#VoucherModule'
            }
        ]
    },
    {
        path: '',
        component: TutorPanelComponent,
        children: [
            {
                path: 'tutor',
                canLoad: [ AuthGuardService ],
                loadChildren: './tutor-panel/courses/tutor-panel-courses.module#TutorPanelCoursesModule'
            },
            {
                path: 'tutor/classes/:id',
                canLoad: [ AuthGuardService ],
                loadChildren: './tutor-panel/classes/tutor-panel-classes.module#TutorPanelClassesModule'
            },
            {
                path: 'tutor/subscribers/:id',
                canLoad: [ AuthGuardService ],
                loadChildren: './tutor-panel/subscribers/tutor-panel-subscribers.module#TutorPanelSubscribersModule'
            }
        ]
    },

];



// WEBPACK FOOTER //
// ./src/app/app.routing.ts